import {
  createNavigationContainerRef,
  getPathFromState,
  getStateFromPath,
  LinkingOptions,
} from '@react-navigation/native'
import * as Linking from 'expo-linking'

import { AppParamList } from './types'

export const navigationRef = createNavigationContainerRef<AppParamList>()

export const linking: LinkingOptions<AppParamList> = {
  prefixes: [
    Linking.createURL('/'),
    'https://*.nextmanager.us',
    'https://nextmanager.us',
    'https://*.nexthelper.us',
    'https://nexthelper.us',
  ],
  config: {
    initialRouteName: 'home',
    screens: {
      home: 'home/',
      auth: 'auth/:code?',
      notifications: 'notifications/',
      schedule: 'schedule/',
      shift: 'schedule_change/',
      request_time_off: 'request_time_off/',
      open_shifts: 'open_shifts/',
      conversations: {
        screens: {
          announcements: 'messages/announcements/',
          dm: 'messages/dm/',
          groups: 'messages/groups/',
          marked: 'messages/marked/',
          sent: 'messages/sent/',
        },
      },
      messages: 'store_chat/',
      tools: 'tools/',
      account: 'user/',
      //WILL THIS WORK ?
      settings: 'settings/',
      setting_item: 'setting_item/',
      filter_chooser: 'filter_chooser/',
      user_profile: 'user_profile/',
      user_list: 'user_list/',
      crew_list: 'crew/',
      user_shifts: 'user_shifts/',
      // store_settings: 'store_settings/',
      time_off_request_list: 'time_off_request/',
      call_out_coverage: 'call_out_coverage/',
    },
  },
  getStateFromPath: (path, options) => {
    return getStateFromPath(path, options)
  },
  getPathFromState: (state, options) => {
    return getPathFromState(state, options)
  },
}

export function gotoRoute(route: string | undefined) {
  if (!route) {
    return
  }

  Linking.openURL(Linking.createURL(route)).catch(err => {
    console.warn('Error going to route ', route, ': ', err)
  })
}
